var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "自动去重",
        visible: _vm.visible,
        width: "552px",
        "append-to-body": true,
        center: "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "fix-form" },
        [
          _c(
            "div",
            { staticClass: "title-con" },
            [
              _c("div", { staticClass: "label-title" }, [
                _vm._v("1.同一审批人在流程中多次出现时，自动去重"),
              ]),
              _c("el-switch", {
                attrs: {
                  "active-color": "#00B498",
                  "inactive-color": "#E4F7F4",
                },
                model: {
                  value:
                    _vm.autoDeduplicationSettings.sameApproverMultipleTimes
                      .enable,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.autoDeduplicationSettings.sameApproverMultipleTimes,
                      "enable",
                      $$v
                    )
                  },
                  expression:
                    "autoDeduplicationSettings.sameApproverMultipleTimes.enable",
                },
              }),
            ],
            1
          ),
          _c(
            "el-radio-group",
            {
              staticClass: "check-group",
              model: {
                value:
                  _vm.autoDeduplicationSettings.sameApproverMultipleTimes
                    .strategy,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.autoDeduplicationSettings.sameApproverMultipleTimes,
                    "strategy",
                    $$v
                  )
                },
                expression:
                  "autoDeduplicationSettings.sameApproverMultipleTimes.strategy",
              },
            },
            [
              _c("el-radio", { attrs: { label: "keepFirst" } }, [
                _c("span", { staticClass: "name-text" }, [
                  _vm._v("在流程中出现多次时，仅保留第一个"),
                ]),
              ]),
              _c("el-radio", { attrs: { label: "deduplicateConsecutive" } }, [
                _c("span", { staticClass: "name-text" }, [
                  _vm._v("仅在连续出现时，自动去重"),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "title-con" },
            [
              _c("div", { staticClass: "label-title" }, [
                _vm._v("2.审批人和发起人是同一个人，审批自动通过"),
              ]),
              _c("el-switch", {
                attrs: {
                  "active-color": "#00B498",
                  "inactive-color": "#E4F7F4",
                },
                model: {
                  value: _vm.autoDeduplicationSettings.approverIsInitiator,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.autoDeduplicationSettings,
                      "approverIsInitiator",
                      $$v
                    )
                  },
                  expression: "autoDeduplicationSettings.approverIsInitiator",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.save } },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }